import { useEffect } from "react";
import { SectionProvider } from "./hooks/useSectionContext";
import { useGetUsersInfo, useProfileQuery } from "../../apis/userApi.hooks";
import { useUserContext } from "./hooks/useUserContext";
import ProfileHeader from "./components/ProfileHeader";
import ProfileSidebar from "./components/sidebar/ProfileSidebar";
import ProfileSections from "./components/ProfileSections";
import SwitchPlanDrawer from "../../standalone/SwitchPlanDrawer/SwitchPlanDrawer";

type UserProfileProps = {
  userUuid: string;
};

export default function UserProfile({ userUuid }: UserProfileProps) {
  const {
    data: profileData,
    isFetching: isProfileLoading,
    isError: isProfileError,
  } = useProfileQuery(userUuid);

  const { setUserEmail, setUserId } = useUserContext();
  const { data: usersInfo, isFetching: isUsersInfoFetching } =
    useGetUsersInfo();

  useEffect(() => {
    if (profileData?.email) {
      setUserEmail(profileData.email)
    }
    if (profileData?.userId) {
      setUserId(profileData.userId)
    }
  }, [profileData, setUserEmail, setUserId])

  return (
    <div className="tw-flex-1 tw-overflow-y-auto tw-p-0">
      <SectionProvider defaultSection="summary">
        <div className="tw-flex tw-flex-col tw-h-full">
          <ProfileHeader
            profileData={profileData}
            isDataLoading={isProfileLoading}
            usersInfo={usersInfo}
            isUsersInfoFetching={isUsersInfoFetching}
          />
          <div className="tw-flex tw-flex-1 tw-overflow-hidden tw-relative">
            <ProfileSidebar />
            <div className="tw-absolute tw-inset-0 sm:tw-left-48 tw-overflow-auto">
              <ProfileSections
                userUuid={userUuid}
                profileData={profileData}
                isDataLoading={isProfileLoading}
                isProfileError={isProfileError}
                usersInfo={usersInfo}
                isUsersInfoFetching={isUsersInfoFetching}
              />
            </div>
          </div>
        </div>
      </SectionProvider>
      <SwitchPlanDrawer />
    </div>
  );
}
